
         function sale_price_info() {
            document.getElementById('sale_price_info').style.display = 'block';
            document.getElementById('pop_black').style.display = 'block';
        }
        function sale_pop_closes() {
            document.getElementById('sale_price_info').style.display = 'none';
            document.getElementById('pop_black').style.display = 'none';
        }
        function btn_pop() {
            document.getElementById('pop_show').style.display = 'block';
            document.getElementById('pop_black').style.display = 'block';
        }
 
        function btn_pop_closes() {
            document.getElementById('return_pop_content').style.display = 'none';
            document.getElementById('pop_show').style.display = 'none';
            document.getElementById('sale_price_info').style.display = 'none';
            document.getElementById('pop_black').style.display = 'none';
        }

        function btn_pop_return() {
            document.getElementById('return_pop_content').style.display = 'block';
            document.getElementById('pop_black').style.display = 'block';
        }


